import { useEffect, useState } from 'react';

interface ToastProps {
  message: string;
  type: 'success' | 'error' | 'info';
  onClose: () => void;
  duration?: number;
}

export function Toast({ message, type, onClose, duration = 3000 }: ToastProps) {
    const [isVisible, setIsVisible] = useState(true);
    useEffect(() => {
        const fadeOutTime = 300; // match with CSS transition duration
        const startFadeOut = setTimeout(() => setIsVisible(false), duration - fadeOutTime);
        const closeTimeout = setTimeout(onClose, duration);

        return () => {
            clearTimeout(startFadeOut);
            clearTimeout(closeTimeout);
        };
    }, [duration, onClose]);

  const bgColor = {
    success: 'bg-green-500',
    error: 'bg-red-500',
    info: 'bg-blue-500',
  }[type];

  return (
    <div className={`
        fixed top-20 right-4 ${bgColor} text-white px-4 py-2 rounded shadow-lg z-50
        transition-opacity duration-300 ease-in-out
        ${isVisible ? 'opacity-100' : 'opacity-0'}
      `}>
      {message}
    </div>
  );
}